import { render, staticRenderFns } from "./CalendarMonth.vue?vue&type=template&id=35be6fda&scoped=true&lang=pug&"
import script from "./CalendarMonth.vue?vue&type=script&lang=js&"
export * from "./CalendarMonth.vue?vue&type=script&lang=js&"
import style0 from "./CalendarMonth.vue?vue&type=style&index=0&id=35be6fda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35be6fda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VSpacer})
